(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-custom-menu"] && !Shopify.designMode) return;
  try {
    // Keep Tab inside the open mobile menu (header-custom-menu.js moves it to <body> and handles Esc/scroll lock).
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const modal = document.querySelector('.header-menu__mobile-modal.is-active');
    if (!modal) return;

    const focusable = [...modal.querySelectorAll('a[href], button:not([disabled])')].filter((el) => el.offsetParent);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first) return;

    const outside = !modal.contains(document.activeElement);
    if (event.shiftKey && (outside || document.activeElement === first)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (outside || document.activeElement === last)) {
      event.preventDefault();
      first.focus();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
